import React from "react";
import { JoeMutexes, Schema } from "../../../../../@types";
import SanitizeHTML from "../../../../../../../components/Sanitize";

export const mutex: Schema<JoeMutexes> = {
  fields: [
    {
      name: "name",
      displayTitle: "Name",
      sortable: true,
      component: d => <>{d.name}</>,
      style: { width: "15%" }
    },
    {
      name: "pid",
      displayTitle: "PID",
      sortable: true,
      component: d => <>{d.pid}</>,
      style: { width: "15%" }
    },
    {
      name: "mutex",
      displayTitle: "Mutexes",
      sortable: true,
      component: d => (
        <ul>
          {d.mutex?.map?.(item => (
            <li key={item.id}>
              Id: {item.id}
              <br />
              Count: {item.count}
              <br />
              Name: {<SanitizeHTML html={item.name} />}
              <br />
              Rawcall: {item.rawcall}
              <br />
              Ret: {item.ret}
              <br />
              Status: {item.status}
              <br />
              Symbol: {item.symbol}
              <br />
              Thread ID: {item.threadid}
              <br />
            </li>
          ))}
        </ul>
      ),
      style: { width: "15%" }
    }
  ]
};
